import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Avatar from 'react-avatar';

const testimonials = [
    {
        image: require('./../../images/testimonials/pic1.jpg'),
        reviewername: 'Andi Prasetyo',
        position: 'HSE Manager',
        review: 'Layanan inspeksi dari PT Riksa Jaya Swastika sangat profesional dan tepat waktu. Semua laporan disampaikan lengkap dan sesuai standar K3.'
    },
    {
        image: require('./../../images/testimonials/pic2.jpg'),
        reviewername: 'Rina Oktaviani',
        position: 'QA Engineer',
        review: 'Tim teknis sangat kooperatif selama proses pengujian. Hasil evaluasi membantu kami meningkatkan keamanan operasional.'
    },
    {
        image: require('./../../images/testimonials/pic3.jpg'),
        reviewername: 'Fahmi Nurhadi',
        position: 'Project Supervisor',
        review: 'Sangat puas dengan ketepatan waktu dan detail laporan dari tim Riksa Jaya. Kami pasti akan bekerja sama kembali untuk proyek berikutnya.'
    }
];


var bnr1 = require('./../../images/background/bg6.jpg');

class Testimonials extends React.Component {
    render() {

        const options = {
            loop:true,
            autoplay:true,
            margin:30,
            nav:false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:1
                },
                991:{
                    items:2
                }
            }
        };

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 square_shape2 bg-cover" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Client</span> Testimonials</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* TESTIMONIAL START */}
                            <OwlCarousel className="owl-carousel testimonial-home" {...options}>
                            
                                {testimonials.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="testimonial-2 m-a30 hover-animation-1">
                                            <div className=" block-shadow bg-white p-a30">
                                                <div className="testimonial-detail clearfix">
                                                    <div className="testimonial-pic radius shadow scale-in-center">
                                                        {/* <img src={item.image} width={100} height={100} alt=""/> */}
                                                        <Avatar name={item.reviewername} size="75" round={true} />
                                                    </div>
                                                    <h4 className="testimonial-name m-b5">{item.reviewername} -</h4>
                                                    <span className="testimonial-position">{item.position}</span>
                                                </div>
                                                <div className="testimonial-text">
                                                    <span className="fa fa-quote-right" />
                                                    <p> {item.review}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>    
                               
                            
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Clients</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Testimonials;